import request from '@/utils/request'

const url = '/auth-service/auths/login'

export function login(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function loginByFrom(params) {
  return request({
    url: `${url}/WRITER_WEB`,
    method: 'post',
    params: params
  })
}

export function getVerifycode(params) {
  return request({
    url: `/auth-service/verifycodes/get_verifycode`,
    method: 'get',
    params: params
  })
}

export function getImageVerifycode(params) {
  return request({
    url: `/auth-service/verifycodes/get_image_verifycode`,
    method: 'get',
    params: params
  })
}

export function loginByWxCode(params) {
  return request({
    url: `/auth-service/wx/oauth2code/${params.appid}`,
    method: 'get',
    params: params
  })
}

export function getTemporaryQrcode(params) {
  return request({
    url: `/auth-service/weixin/${params.appid}/temporary_qrcode`,
    method: 'get',
    params: params
  })
}

export function loginLoop(params) {
  return request({
    url: `/auth-service/weixin/${params.appid}/loop`,
    method: 'get',
    params: params
  })
}

export function ecloudSign(params) {
  return request({
    url: `/auth-service/ecloud/${params.appid}/sign`,
    method: 'get',
    params: params
  })
}

export function ecloudPhone(params) {
  return request({
    url: `/auth-service/ecloud/${params.appid}/phone`,
    method: 'get',
    params: params
  })
}

export function saveTempToken(params) {
  return request({
    url: `/auth-service/auths/temp_token_save`,
    method: 'get',
    params: params
  })
}

export function getTempToken(params) {
  return request({
    url: `/auth-service/auths/temp_token_get`,
    method: 'get',
    params: params
  })
}
